export class NewsError extends Error {}
